import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Wrapper = styled(FlexRow)`
  width: 100vh;
  height: 100%;
  overflow: hidden;

  ${QUERIES.tabletAndUp} {
    width: 100%;
  }
`;

export const LeftColumn = styled(FlexColumn)`
  padding: 46px 28px;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  box-sizing: border-box;

  ${QUERIES.largeTabletAndUp} {
    width: calc(100% - 550px);
    align-items: start;
    flex-shrink: 0;
    padding: 46px 48px;
    justify-content: center;
  }

  ${QUERIES.laptopAndUp} {
    width: calc(100% - 600px);
  }
`;

export const RightColumn = styled(FlexColumn)`
  display: none;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: ${themeStyle.varInkSuperLight};

  ${QUERIES.largeTabletAndUp} {
    display: flex;
  }
`;

export const ImageWrapper = styled.div<{
  background: string;
  isNewThemeActive: boolean;
}>`
  flex-grow: 1;
  max-width: 100%;
  height: 300px;
  width: 300px;

  background: ${({ background }) =>
    background ? `url(${background})` : undefined};
  background-size: ${({ isNewThemeActive }) =>
    isNewThemeActive ? 'contain' : 'cover'};
  background-position-x: center;
  background-position-y: center;
  background-repeat: no-repeat;
`;

export const Link = styled.a`
  color: ${themeStyle.varInkMedium};

  &:hover {
    color: ${themeStyle.varInkMain};
  }
`;
